import { DataGridPro } from '@mui/x-data-grid-pro';
import React from 'react';
import { useSelector } from 'react-redux';
import withDataLoaded from '../with_data_loaded';
import PageSpinner from '../shared/page_spinner';
import { companyAuditLogLoader } from '../../actions/data_loaders';
import DisplayHelper from '../../helpers/display_helper';
import Constants from '../../helpers/constants';

function CompanyDetailsAuditTable() {
  let auditLogList = useSelector((state) => state.auditLogs);
  if (!(auditLogList?.length !== 0)) {
    auditLogList = [];
  }

  const tenseMap = {
    create: 'created',
    delete: 'deleted',
    update: 'updated',
    deactivate: 'deactivated',
    'product migrate': 'product migrated',
    disable: 'disabled',
    add: 'added',
    remove: 'removed',
  };

  const getLenderLabel = (val) => {
    const lenderLabel = Constants.LENDERS?.find((lender) => `"${lender.productSku}"` === val)?.label;
    return lenderLabel ? `"${lenderLabel}"` : val;
  };

  const columns = [
    {
      field: 'dateCreated',
      headerName: 'Date/Time',
      minWidth: 120,
      valueFormatter: ({ value }) => DisplayHelper.formatDateV2(value),
    },
    {
      field: 'event',
      headerName: 'Event',
      flex: 1,
      sortable: false,
      valueGetter: ({ row }) => {
        let value = '';
        if (row.value) {
          let email = row.value.match(/{"emailAddress": "(?<email>.*)"} (?<detail>\(.*\))/);
          value = email?.groups ? `"${email.groups.email} ${email.groups.detail}"` : `${row.value}`;
          if (!row.value.includes('"')) {
            value = `"${value}"`;
          }
        }
        return `${row.subject} ${tenseMap[row.verb] ?? row.verb} ${row.object} ${getLenderLabel(value)}`;
      },
    },
  ];

  return (
    <div id={'company-history-table'} style={{ height: 420, width: '100%' }}>
      <DataGridPro
        className="history-x-datagrid"
        disableColumnMenu={true}
        rows={auditLogList}
        rowHeight={28}
        columns={columns}
        pageSize={100}
        rowsPerPageOptions={[100]}
        disableSelectionOnClick={true}
      />
    </div>
  );
}

export default withDataLoaded({
  WithData: CompanyDetailsAuditTable,
  WithoutData: PageSpinner,
  data: [companyAuditLogLoader],
  EmptyArrayIsStillData: true,
});
